import { NAVIGATION_ROUTES } from './NavigationUtils';

export const PROFILE_IMAGE_BASE_URL =
  'https://api.rebet.app/admin_panel/v2/admin';

export const ADMIN_PANEL_BACKEND_BASE_URL =
  'https://api.rebet.app/admin_panel/v2/admin';
export const ADMIN_DASHBOARD_BACKEND_BASE_URL =
  'https://y1s0b9goh2.execute-api.us-east-2.amazonaws.com/prod';
export const AFFILIATE_PANEL_BACKEND_INSTANCE =
  'https://559xyery3g.execute-api.us-east-2.amazonaws.com/dev/admin-management-v3';

export const USER_PROFILE_PICTURE_BASE_URL =
  'https://rebet-user-profile.s3.us-east-2.amazonaws.com';

// Public assets base: sport/league logos bucket
export const SPORT_LOGO_BASE_URL =
  'https://rebet-backend.s3.us-east-2.amazonaws.com/league_logos';

export const ONBOARDING_PAGE_STATE = {
  LOGIN: 'login',
  SIGNUP: 'signup',
};

export const SIDER_TABS = {
  USERS: 'Users',
  USERS_NEW: 'Users - New',
  PLAYERS: 'Players - DEMO',
  SPORTSBOOK: 'Sportsbook',
  MAIN_SPORTSBOOK: 'Main Sportsbook',
  KPIS: 'KPIs',
  AFFILIATE: 'Affiliates',
  ADMIN: 'Admin',
  EVENTS: 'Events',
  STAFF_MANAGEMENT: 'Staff Management',
  PAYMENTS: 'Payments',
  FINIX_DELAYED_PAYMENT: 'Finix Delayed Payment',
  PRIZE_REDEMPTION_MANUAL_REVIEW: 'Prize Redemption Manual Review',
  PROMOTIONS: 'Promotions',
  CONFIGURATIONS: 'Configuration',
  DASHBOARD: 'Dashboard',
  REPORTS: 'Reports',
  MARKETING: 'Marketing',
  CASINO: 'Casino',
  TRANSACTIONS: 'Transactions',
};

export const USER_HEADER_TABS = {
  OVERVIEW: 'overview',
  TRANSACTIONS: 'transactions',
  BETS: 'bets',
  CASINO_BETS: 'casino-bets',
  POKER_BETS: 'poker-bets',
  GAME_PASS: 'game-pass',
  ALT_ODS: 'alt-ods',
};

export const SPORTSBOOK_HEADER_TABS = {
  LEAGUES: 'Leagues',
};

export const KPI_HEADER_TABS = {
  USERS: 'Users',
  BETS: 'Bets',
  FINANCIALS: 'Financials',
  TRANSACTIONS: 'Transactions',
  STATES: 'States',
};

export const AFFILIATE_HEADER_TABS = {
  AFFILIATE_KPIS: 'Affiliate KPIs',
  FINANCIALS: 'Financials',
  INDIVIDUAL_STATS: 'Individual Stats',
};

export const TIME_FRAMES = {
  MONTH: 'month',
  DAY: 'day',
};

export const NUM_WEEKS = {
  ONE: '1 week',
  TWO: '2 weeks',
  THREE: '3 weeks ',
  FOUR: '4 weeks',
  MONTHLY: 'Monthly',
};

export const DATE_RANGE = {
  LAST_7_DAYS: 'Last 7 days',
  LAST_21_DAYS: 'Last 21 days',
  LAST_30_DAYS: 'Last 30 days',
  LAST_45_DAYS: 'Last 45 days',
};

export const BET_TYPES = {
  STRAIGHT: 'straight',
  GROUP: 'group',
  PARLAY: 'parlay',
  P2P: 'p2p',
};

export const BET_STATUS = {
  WON: 'won',
  LOST: 'lost',
  PUSHED: 'pushed',
  UNSETTLED: 'unsettled',
  CANCELLED: 'cancelled',
};

export const ADMIN_TYPES = {
  SUPER_ADMIN: 'super-admin-v2',
  CUSTOMER_SUPPORT: 'customer-support',
  COMPLIANCE_AGENT: 'compliance-agent',
};

export const PERSONAL_LIMITS = {
  TIME_LIMITS: 'time limits',
  CURRENCY_LIMITS: 'currency limits',
  WAGGER_LIMITS: 'wagger limits',
  LOSS_LIMITS: 'loss limits',
  CASINO_LIMITS: 'casino limits',
};

export const KPI_CARD_BACKGROUND = {
  LIGHT: '#25252F',
  DARK: '#1A1A22',
  TRASNPARENT: 'transparent',
};

export const FREE_BET_TYPES = {
  WAGERED: 'wagered',
  PAIDOUT: 'paidout',
};

export const CHURN_RISK_LEVELS = {
  LOW: '#F1C40F',
  MEDIUM: '#F39C12',
  HIGH: '#FD6F27',
  CRITICAL: '#E74C3C',
};

export const CONFIGURATIONS_OPTIONS = [
  // { id:"configuration-location-restrictions", label: "Location Restrictions", navigate: NAVIGATION_ROUTES?.LOCATIONS_RESTRICTIONS },
  {
    id: 'configuration-casino-fm',
    label: 'Casino FM',
    navigate: NAVIGATION_ROUTES?.CASINO_FM,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
  {
    id: 'configuration-sportsbook-fm',
    label: 'Sportsbook FM',
    navigate: NAVIGATION_ROUTES?.SPORTSBOOK_FM,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
];

export const MARKETING_OPTIONS = [
  {
    id: 'marketing-affiliates',
    label: 'Affiliates',
    navigate: NAVIGATION_ROUTES?.MARKETING_AFFILIATES,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
];

export const SPORTSBOOK_OPTIONS = [
  {
    id: 'sportsbook',
    label: 'Sportsbook',
    navigate: NAVIGATION_ROUTES?.SPORTSBOOK,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
  // {
  //   id: 'main-sportsbook',
  //   label: 'Main Sportsbook',
  //   navigate: NAVIGATION_ROUTES?.MAIN_SPORTSBOOK,
  //   visible: [ADMIN_TYPES?.SUPER_ADMIN]
  // },
  //  {
  //    id: "bets-report",
  //    label: "Bets Report",
  //    navigate: NAVIGATION_ROUTES?.SPORTSBOOK_BETS_REPORT,
  //  },
];

export const PROMOTIONS_OPTIONS = [
  { id: 'default', label: 'Default', 
    navigate: NAVIGATION_ROUTES?.PROMOTIONS, 
    visible: [ADMIN_TYPES?.SUPER_ADMIN] 
  },
  //  {
  //    id: "promotions-management",
  //    label: "Management",
  //    navigate: NAVIGATION_ROUTES?.PROMOTIONS_MANAGEMENT,
  //  },
];

export const TRANSACTIONS_OPTIONS = [
  // {
  //   id: "processors",
  //   label: "Processors",
  //   navigate: NAVIGATION_ROUTES?.TRANSACTIONS_PROCESSORS,
  // },
  {
    id: 'transactions-overview',
    label: 'Overview',
    navigate: NAVIGATION_ROUTES?.TRANSACTIONS_OVERVIEW,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
  {
    id: 'transactions-wallet',
    label: 'Wallet',
    navigate: NAVIGATION_ROUTES?.TRANSACTIONS_WALLET,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
  {
    id: 'transactions-reports',
    label: 'Reports',
    navigate: NAVIGATION_ROUTES?.TRANSACTIONS_REPORTS,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
  {
    id: 'withdrawal-review',
    label: 'Withdrawal Review',
    navigate: NAVIGATION_ROUTES?.WITHDRAWAL_REVIEW,
    visible: [ADMIN_TYPES?.SUPER_ADMIN, ADMIN_TYPES?.COMPLIANCE_AGENT]

  },
];

export const STAFF_MANAGEMENT_OPTIONS = [
  {
    id: 'agent-dashboard',
    label: 'Agent Dashboard',
    navigate: NAVIGATION_ROUTES?.AGENT_DASHBOARD,
    visible: [ADMIN_TYPES?.CUSTOMER_SUPPORT, ADMIN_TYPES?.SUPER_ADMIN, ADMIN_TYPES?.COMPLIANCE_AGENT]
  },
  {
    id: 'manual-entries',
    label: 'Manual Entries',
    navigate: NAVIGATION_ROUTES?.MANUAL_ENTRIES,
    visible: [ADMIN_TYPES?.CUSTOMER_SUPPORT, ADMIN_TYPES?.SUPER_ADMIN]
  },
];

export const PAYMENTS_OPTIONS = [
  {
    id: 'finix-delayed-payment',
    label: 'Finix Delayed Payment',
    navigate: NAVIGATION_ROUTES?.FINIX_DELAYED_PAYMENT,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
  // {
  //   id: "prize-redemption-manual-review",
  //   label: "Prize Redemption Manual Review",
  //   navigate: NAVIGATION_ROUTES?.PRIZE_REDEMPTION_MANUAL_REVIEW,
  // },
  // {
  //   id: "prize-redemption-manual-review-tracking",
  //   label: "Redemption Manual Review Tracking",
  //   navigate: NAVIGATION_ROUTES?.PRIZE_REDEMPTION_MANUAL_REVIEW_TRACKING,
  // },
];

export const ADMIN_OPTIONS = [
  {
    id: 'create-account',
    label: 'Create Account',
    navigate: NAVIGATION_ROUTES?.CREATE_ACCOUNT,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
  {
    id: 'customer-support-controls',
    label: 'Customer Support Controls',
    navigate: NAVIGATION_ROUTES?.CUSTOMER_SUPPORT_CONTROLS,
    visible: [ADMIN_TYPES?.SUPER_ADMIN]
  },
];

